type LinkProps = {
  text: string;
  link?: string;
  onClick?: () => any;
};

const AuthLink = ({ text, link, onClick }: LinkProps) => {
  return (
    <a className="authentication__link" href={link} onClick={onClick}>
      {text}
    </a>
  );
};

export default AuthLink;
